export default "__VITE_ASSET__VGTYn51Y__"